module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v(_vm._s(_vm.$t('groupPages.modules.pictures.title')))]), _c('ul', {
    directives: [{
      name: "sortable",
      rawName: "v-sortable",
      value: ({
        onUpdate: _vm.onListReorder,
        handle: '.drag-handle'
      }),
      expression: "{onUpdate: onListReorder, handle: '.drag-handle'}"
    }],
    staticClass: "pictures"
  }, _vm._l((_vm.shownPictures), function(picture, index) {
    return _c('li', {
      style: ({
        'background-image': 'url(' + picture.src + ')'
      }),
      on: {
        "click": function($event) {
          return _vm.clickThumbnail(picture, index)
        }
      }
    }, [(_vm.openEditor) ? [_c('i', {
      staticClass: "text-danger fa fa-trash",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.remove(picture)
        }
      }
    })] : _vm._e()], 2)
  }), 0), (_vm.openEditor) ? _c('div', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.askUpload
    }
  }, [_c('div', {
    staticClass: "alert alert-info text-center"
  }, [_c('i', {
    staticClass: "fa fa-upload fa-2x"
  }), _c('br'), _vm._v(" " + _vm._s(_vm.$t('groupPages.modules.pictures.import')))])]) : _vm._e(), (_vm.module.items.length > _vm.limit) ? _c('div', {
    staticClass: "pcenter"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.showMore
    }
  }, [_vm._v(_vm._s(_vm.$t('groupPages.modules.pictures.more')))])]) : _vm._e(), _c('div', {
    ref: "pswp",
    staticClass: "pswp",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "pswp__bg"
  }), _vm._m(0)]), _c('div', {
    staticClass: "cf"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pswp__scroll-wrap"
  }, [_c('div', {
    staticClass: "pswp__container"
  }, [_c('div', {
    staticClass: "pswp__item"
  }), _c('div', {
    staticClass: "pswp__item"
  }), _c('div', {
    staticClass: "pswp__item"
  })]), _c('div', {
    staticClass: "pswp__ui pswp__ui--hidden"
  }, [_c('div', {
    staticClass: "pswp__top-bar"
  }, [_c('div', {
    staticClass: "pswp__counter"
  }), _c('button', {
    staticClass: "pswp__button pswp__button--close",
    attrs: {
      "title": "Close (Esc)"
    }
  }), _c('button', {
    staticClass: "pswp__button pswp__button--share",
    attrs: {
      "title": "Share"
    }
  }), _c('button', {
    staticClass: "pswp__button pswp__button--fs",
    attrs: {
      "title": "Toggle fullscreen"
    }
  }), _c('button', {
    staticClass: "pswp__button pswp__button--zoom",
    attrs: {
      "title": "Zoom in/out"
    }
  }), _c('div', {
    staticClass: "pswp__preloader"
  }, [_c('div', {
    staticClass: "pswp__preloader__icn"
  }, [_c('div', {
    staticClass: "pswp__preloader__cut"
  }, [_c('div', {
    staticClass: "pswp__preloader__donut"
  })])])])]), _c('div', {
    staticClass: "pswp__share-modal pswp__share-modal--hidden pswp__single-tap"
  }, [_c('div', {
    staticClass: "pswp__share-tooltip"
  })]), _c('button', {
    staticClass: "pswp__button pswp__button--arrow--left",
    attrs: {
      "title": "Previous (arrow left)"
    }
  }), _c('button', {
    staticClass: "pswp__button pswp__button--arrow--right",
    attrs: {
      "title": "Next (arrow right)"
    }
  }), _c('div', {
    staticClass: "pswp__caption"
  }, [_c('div', {
    staticClass: "pswp__caption__center"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7dc58f54","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GroupPages/GroupPagePictures.vue
// module id = 1275
// module chunks = 2